import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getOutbound,
  getIdOutbound,
  createOutbound,
  updateOutbound,
  deleteOutbound,
  updateOutboundSetStatus,
  updateOutboundConfirm,
  updateOutboundCancel,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteOutboundVehicles,
  createParty,
  updateParty,
  deleteParty,
  getparty,
  getTransportations,
  createTransportations,
  updateTransportations,
  deleteTransportations,
  updateOutboundStartWorkFlow,
  uploadOutbound,
  updateOutboundAmend,
  uploadPicking,
  uploadBTS,
  getGenerateExcelBlob
} from "./outboundAPI";

const initialState = {
  data: [],
  dataParty: [],
  dataPartyAll: [],
  dataTransportations: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  pageNoParty: 1,
  pageSizeParty: 10,
  totalRecordParty: 0,

  pageNoTransportations: 1,
  pageSizeTransportations: 10,
  totalRecordTransportations: 0,

  permissionsPicking: [],
  permissionsHandover: [],
  permissionsBts: [],
  permissionsList: [],
};

export const fetchOutbound = createAsyncThunk(
  "Outbound/fetchOutbound",
  async (payload) => {
    const response = await getOutbound(payload);
    return response;
  }
);

export const addOutbound = createAsyncThunk(
  "Outbound/addOutbound",
  async (payload) => {
    const response = await createOutbound(payload);
    return response;
  }
);

export const editOutbound = createAsyncThunk(
  "Outbound/editOutbound",
  async (payload) => {
    const response = await updateOutbound(payload);
    return response;
  }
);

export const editOutboundConfirm = createAsyncThunk(
  "Outbound/editOutboundConfirm",
  async (payload) => {
    const response = await updateOutboundConfirm(payload);
    return response;
  }
);
export const editOutboundAmend = createAsyncThunk(
  "Outbound/editOutboundAmend",
  async (payload) => {
    const response = await updateOutboundAmend(payload);
    return response;
  }
);

export const editOutboundCancel = createAsyncThunk(
  "Outbound/editOutboundCancel",
  async (payload) => {
    const response = await updateOutboundCancel(payload);
    return response;
  }
);

export const editOutboundStarWorkflow = createAsyncThunk(
  "Outbound/editOutboundStarWorkflow",
  async (payload) => {
    const response = await updateOutboundStartWorkFlow(payload);
    return response;
  }
);

export const fetchIdOutbound = createAsyncThunk(
  "Outbound/fetchIdOutbound",
  async (id) => {
    const response = await getIdOutbound(id);
    return response;
  }
);

export const removeOutbound = createAsyncThunk(
  "Outbound/removeOutbound",
  async (payload) => {
    const response = await deleteOutbound(payload);
    return response;
  }
);

export const AddUploadFile = createAsyncThunk(
  "Outbound/AddUploadFile",
  async ({ id, file }) => {
    const response = await uploadOutbound(id, file);
    return response;
  }
);

export const AddUploadFilePicking = createAsyncThunk(
  "Outbound/AddUploadFilePicking",
  async ({ id, file }) => {
    const response = await uploadPicking(id, file);
    return response;
  }
);
export const AddUploadFileBTS = createAsyncThunk(
  "Outbound/AddUploadFileBTS",
  async ({ id, file }) => {
    const response = await uploadBTS(id, file);
    return response;
  }
);

// vihicle
export const fetchOutboundVehicle = createAsyncThunk(
  "Outbound/fetchOutboundVehicle",
  async (payload) => {
    const response = await getVehicle(payload);
    return response;
  }
);

export const addOutboundVehicle = createAsyncThunk(
  "Outbound/addOutboundVehicle",
  async (payload) => {
    const response = await createVehicle(payload);
    return response;
  }
);
export const removeOutboundVehicle = createAsyncThunk(
  "Outbound/removeOutboundVehicle",
  async (payload) => {
    const response = await deleteOutboundVehicles(payload);
    return response;
  }
);

export const editOutboundVehicle = createAsyncThunk(
  "Outbound/editOutboundVehicle",
  async (payload) => {
    const response = await updateVehicle(payload);
    return response;
  }
);

// party
export const fetchOutboundParty = createAsyncThunk(
  "Outbound/fetchOutboundParty",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);
export const fetchOutboundPartyAll = createAsyncThunk(
  "Outbound/fetchOutboundPartyAll",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);

export const addOutboundParty = createAsyncThunk(
  "Outbound/addOutboundParty",
  async (payload) => {
    const response = await createParty(payload);
    return response;
  }
);

export const editOutboundParty = createAsyncThunk(
  "Outbound/editOutboundParty",
  async (payload) => {
    const response = await updateParty(payload);
    return response;
  }
);

export const removeOutboundParty = createAsyncThunk(
  "Outbound/removeOutboundParty",
  async (payload) => {
    const response = await deleteParty(payload);
    return response;
  }
);

// Transportations
export const fetchOutboundTransportations = createAsyncThunk(
  "Outbound/fetchOutboundTransportations",
  async (payload) => {
    const response = await getTransportations(payload);
    return response;
  }
);

export const addOutboundTransportations = createAsyncThunk(
  "Outbound/addOutboundTransportations",
  async (payload) => {
    const response = await createTransportations(payload);
    return response;
  }
);

export const editOutboundTransportations = createAsyncThunk(
  "Outbound/editOutboundTransportations",
  async (payload) => {
    const response = await updateTransportations(payload);
    return response;
  }
);

export const removeOutboundTransportations = createAsyncThunk(
  "Outbound/removeOutboundTransportations",
  async (payload) => {
    const response = await deleteTransportations(payload);
    return response;
  }
);

// Generate Excel
export const fetchGenerateExcel = createAsyncThunk(
  "Outbond/fetchGenerateExcel",
  async (payload) => {
    const response = await getGenerateExcelBlob(payload);
    return response;
  }
);

export const OutboundSlice = createSlice({
  name: "Outbound",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermisionPicking: (state, action) => {
      state.permissionsPicking = action.payload;
    },
    setPermisionHandover: (state, action) => {
      state.permissionsHandover = action.payload;
    },
    setPermisionBts: (state, action) => {
      state.permissionsBts = action.payload;
    },
    setPermisionList: (state, action) => {
      state.permissionsList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOutbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOutbound.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdOutbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdOutbound.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addOutbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOutbound.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editOutbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutbound.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOutboundConfirm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutboundConfirm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOutboundAmend.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutboundAmend.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOutboundCancel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutboundCancel.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOutboundStarWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutboundStarWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFilePicking.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFilePicking.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileBTS.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileBTS.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeOutbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeOutbound.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchOutboundVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOutboundVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(addOutboundVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOutboundVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOutboundVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutboundVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeOutboundVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeOutboundVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // party
      .addCase(fetchOutboundParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOutboundParty.fulfilled, (state, action) => {
        state.loading = false;
        state.dataParty = action.payload.data.data;
        state.pageNoParty = action.payload.data.pageNo;
        state.pageSizeParty = action.payload.data.pageSize;
        state.totalRecordParty = action.payload.data.totalRecord;
      })
      .addCase(fetchOutboundPartyAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOutboundPartyAll.fulfilled, (state, action) => {
        state.loading = false;
        state.dataPartyAll = action.payload.data.data;
      })
      .addCase(addOutboundParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOutboundParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOutboundParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutboundParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeOutboundParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeOutboundParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // Transportations
      .addCase(fetchOutboundTransportations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOutboundTransportations.fulfilled, (state, action) => {
        state.loading = false;
        state.dataTransportations = action.payload.data.data;
        state.pageNoTransportations = action.payload.data.pageNo;
        state.pageSizeTransportations = action.payload.data.pageSize;
        state.totalRecordTransportations = action.payload.data.totalRecord;
      })
      .addCase(addOutboundTransportations.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOutboundTransportations.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editOutboundTransportations.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOutboundTransportations.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeOutboundTransportations.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeOutboundTransportations.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermisionBts,
  setPermisionHandover,
  setPermisionPicking,
  setPermisionList,
} = OutboundSlice.actions;

export const selectOutbound = (state) => state.Outbound.data;
export const selectOutboundVehicle = (state) => state.Outbound.data;
export const selectIdOutbound = (state) => state.Outbound.dataId;
export const selectLoading = (state) => state.Outbound.loading;
export const selectError = (state) => state.Outbound.error;
export const selectPageNo = (state) => state.Outbound.pageNo;
export const selectPageSize = (state) => state.Outbound.pageSize;
export const selectTotalRecord = (state) => state.Outbound.totalRecord;
export const selectSelected = (state) => state.Outbound.selected;
export const selectResult = (state) => state.Outbound.result;
export const selectOutboundParty = (state) => state.Outbound.dataParty;
export const selectOutboundPartyAll = (state) => state.Outbound.dataPartyAll;

export const selectPageNoParty = (state) => state.Outbound.pageNoParty;
export const selectPageSizeParty = (state) => state.Outbound.pageSizeParty;
export const selectTotalRecordParty = (state) =>
  state.Outbound.totalRecordParty;

export const selectOutboundTransportations = (state) =>
  state.Outbound.dataTransportations;
export const selectPageNoTransportations = (state) =>
  state.Outbound.pageNoTransportations;
export const selectPageSizeTransportations = (state) =>
  state.Outbound.pageSizeTransportations;
export const selectTotalRecordTransportations = (state) =>
  state.Outbound.totalRecordTransportations;

export const selectPermissionPicking = (state) =>
  state.Outbound.permissionsPicking;
export const selectPermissionHandover = (state) =>
  state.Outbound.permissionsHandover;
export const selectPermissionBts = (state) => state.Outbound.permissionsBts;
export const selectPermissionList = (state) => state.Outbound.permissionsList;
export default OutboundSlice.reducer;
